module.exports = __webpack_public_path__ + "static/media/old_man_tattoo_larskrutak.eb8b8ccf.jpg";